<span class="value text-uppercase qa-sale-type"
      *ngIf="value && conquestType != conquestTypes.notConverted" translate="{{saleTypeTranslateKeys[value]}}"></span>
<span class="value text-uppercase qa-sale-type" translate="conquest"
      *ngIf="!value && (conquestType == conquestTypes.notConverted || conquestType == conquestTypes.creditConvert)">
</span>
<span *ngIf="saleTypeOriginalLookupId > 0">
    <span> - </span><span class="qa-sale-type-original" translate="{{saleTypeOriginalLookupKey}}"></span>
</span>
